import React from 'react'
import { IonContent, IonImg, IonPage } from '@ionic/react'
import { useTranslation } from 'react-i18next'
import './Landing.page.css'

type AppStore = {
  href: string
  rel: string
  logo: LogoImage
}

type LogoImage = {
  src: string
  altText: string
  className?: string
}

const logo: LogoImage = {
  src: '/assets/images/zoll-logo-white-now.png',
  altText: 'Zoll Logo',
}

const ios: AppStore = {
  href: `${process.env.REACT_APP_APP_STORE_URL_IOS}`,
  rel: 'Apple Store',
  logo: {
    src: '/assets/images/iOS-AppStore.png',
    altText: 'Apple Store',
    className: 'apple-btn',
  },
}

const android: AppStore = {
  href: `${process.env.REACT_APP_APP_STORE_URL_ANDROID}`,
  rel: 'Google Store',
  logo: {
    src: '/assets/images/Google-AppStore.png',
    altText: 'Google Store',
    className: 'google-btn',
  },
}

const Landing: React.FC = () => {
  const { t } = useTranslation()

  return (
    <IonPage>
      <IonContent fullscreen>
        <div
          className='landing-page'
          style={{ backgroundImage: 'url(' + '/assets/images/Background-stretch.png' + ')' }}>
          <div className='logo-row'>
            <IonImg src={logo.src} alt={logo.altText} />
          </div>
          <div>
            <div className='title-text'>{t('landingPage.LandingPageTitle')}</div>
            <div className='sub-text'>{t('landingPage.LandingPageSubTitle')}</div>
          </div>
          <div className='landing-bottom'>
            <div className='app-store'>
              <a href={ios.href} rel={ios.rel}>
                <img src={ios.logo.src} className={ios.logo.className} alt={ios.logo.altText} />
              </a>
              <a href={android.href} rel={android.rel}>
                <img src={android.logo.src} className={android.logo.className} alt={android.logo.altText} />
              </a>
            </div>
            <div className='phone-img-section'>
              <img src='/assets/images/phone_image.png' className='phone-img' alt='emsCHARTS Img' />
            </div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  )
}

export default Landing
